














































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from 'vivat';
import _ from 'lodash';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonChip from '@/components/CommonChip.vue';
import CommonTableFooter from '@/components/CommonTableFooter.vue';
import CommonFormWithInvoiceEditor from '@/components/Invoice/CommonFormWithInvoiceEditor.vue';

import orderList from '@/table/invoices/orderList';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';
import countDelivery from '@/gql/invoice/countDelivery.gql';
import batchDisconnectDeliveries from '@/gql/invoice/batchDisconnectDeliveries.gql';
import getInvoiceStats from '@/gql/invoice/getDailyStats.gql';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDownloadReport from '@/useDownloadReport';

const BillList = defineComponent({
  components: {
    CommonIconTop,
    CommonChip,
    CommonTableFooter,
    CommonDeliveryStatusSelect,
    CommonFormWithInvoiceEditor,
    CommonModalWithPreset,
    PrettyCheck,
  },
  setup() {
    const { router } = useRouter();
    const { distanceTypeToChipClass } = useDeliveryAreaCode();
    const { getPDFReport } = useDownloadReport();
    const toCommaFormat = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const NOW = useFormat.date().computerShortDate();
    const toCurrency = (str: string | number) => useFormat.number(str).currency();

    const forceReload: Ref<boolean> = ref(true);
    const { result: invoiceStatsResult, loading } = useQuery(getInvoiceStats);
    const invoiceStats = useResult(invoiceStatsResult, { total: 0 }, (data: any) => data.invoiceStats);

    const editId = ref(-1);

    const selectedItemId: number[] = reactive([]);
    const selectedItemHasInvoice: boolean[] = reactive([]);
    function selectItem(id: number | string, invoice: { code: string }) {
      const hitIndex = selectedItemId.indexOf(parseInt(id as string, 10));
      if (hitIndex > -1) {
        selectedItemId.splice(hitIndex, 1);
        selectedItemHasInvoice.splice(hitIndex, 1);
      } else {
        selectedItemId.push(parseInt(id as string, 10));
        selectedItemHasInvoice.push(invoice?.code !== undefined);
      }
    }

    const clearDeliveries = () => {
      forceReload.value = false;
      editId.value = -1;
      selectedItemId.splice(0);
      forceReload.value = true;
    };

    const modal = ref(null);
    const errorModal = ref(null);

    const createInvoice = () => {
      if (selectedItemId.length === 0) (errorModal.value as any).compose();
      else (modal.value as any).open();
    };
    const editInvoice = () => {
      (modal.value as any).open();
    };
    const close = () => {
      (modal.value as any).close();
    };

    const filter = reactive({
      status: '',
      orderNumber: '',
      orderNumberInput: '',
      orderDate: {
        from: undefined,
        to: undefined,
      },
    });
    const orderNumberInput = _.debounce(() => {
      filter.orderNumber = filter.orderNumberInput;
    }, 500);
    function clickDateHandler(date: any) {
      if (filter.orderDate.from === useFormat.date(date).computerShortDate()) {
        filter.orderDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.orderDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }
    const computedDateInput = computed(() => ({
      from: filter.orderDate.from ? `${filter.orderDate.from} 00:00:00` : undefined,
      to: filter.orderDate.from ? `${filter.orderDate.to} 23:59:59` : undefined,
      // from: '1970-01-01 00:00:00',
      // to: '1970-01-01 23:59:59',
    }));

    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filterByStatus: undefined,
        searchOrderNumber: undefined,
        filterOrderDateBetween: undefined,
        filterHasDeliveryNote: true,
      };
      if (filter.status) {
        vars.filterByStatus = filter.status;
      }
      if (filter.orderNumber) {
        vars.searchOrderNumber = `%${filter.orderNumber}%`;
      }
      if (filter.orderDate.from) {
        vars.filterOrderDateBetween = computedDateInput.value;
      }
      return vars;
    });
    const getOrdersResult = (data: any) => data.deliveries;

    const orderStatusCounter = reactive({
      CANCEL: 0,
      ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER: 0,
      PREPARE_TO_DELIVER: 0,
      ON_THE_WAY: 0,
      SUCCESS: 0,
      NOT_SUCCESS: 0,
      total: 0,
      HAS_INVOICE: 0,
    });
    const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(countDelivery, () => ({
      // filterOrderDateBetween: computedDateInput.value.from ? computedDateInput.value : undefined,
      filterHasDeliveryNote: true,
    }), () => ({
      fetchPolicy: 'network-only',
    }));
    const countDeliveryResult = useResult(getCountDeliveryResult, [
      { status: 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER', count: 0 },
      { status: 'PREPARE_TO_DELIVER', count: 0 },
      { status: 'ON_THE_WAY', count: 0 },
      { status: 'CANCEL', count: 0 },
      { status: 'SUCCESS', count: 0 },
      { status: 'NOT_SUCCESS', count: 0 },
      { status: 'HAS_INVOICE', count: 0 },
    ], (data) => data.countDelivery);
    const totalDeliveryResult = useResult(getCountDeliveryResult, 0, (data) => data.totalDelivery.paginatorInfo.total);
    watch(() => totalDeliveryResult.value, (newVal, oldVal) => {
      if (!countDeliveryLoading.value && newVal !== oldVal) {
        orderStatusCounter.total = totalDeliveryResult.value as any;
        orderStatusCounter.ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER = countDeliveryResult.value.find((countObj: any) => countObj.status === 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER')?.count || 0;
        orderStatusCounter.PREPARE_TO_DELIVER = countDeliveryResult.value.find((countObj: any) => countObj.status === 'PREPARE_TO_DELIVER')?.count || 0;
        orderStatusCounter.ON_THE_WAY = countDeliveryResult.value.find((countObj: any) => countObj.status === 'ON_THE_WAY')?.count || 0;
        orderStatusCounter.SUCCESS = countDeliveryResult.value.find((countObj: any) => countObj.status === 'SUCCESS')?.count || 0;
        orderStatusCounter.NOT_SUCCESS = countDeliveryResult.value.find((countObj: any) => countObj.status === 'NOT_SUCCESS')?.count || 0;
        orderStatusCounter.CANCEL = countDeliveryResult.value.find((countObj: any) => countObj.status === 'CANCEL')?.count || 0;
        orderStatusCounter.HAS_INVOICE = countDeliveryResult.value.find((countObj: any) => countObj.status === 'HAS_INVOICE')?.count || 0;
      }
    });

    const statusChartValue = computed(() => [
      { data: orderStatusCounter.ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER, name: 'รับสินค้าเข้าแล้ว', color: 'yellow' },
      { data: orderStatusCounter.CANCEL, name: 'ยกเลิกรายการ', color: 'gray' },
      { data: orderStatusCounter.PREPARE_TO_DELIVER, name: 'เตรียมส่ง', color: 'purple' },
      { data: orderStatusCounter.ON_THE_WAY, name: 'กำลังจัดส่งสินค้า', color: 'indigo' },
      { data: orderStatusCounter.NOT_SUCCESS, name: 'ส่งไม่สำเร็จ', color: 'green' },
      { data: orderStatusCounter.SUCCESS, name: 'ส่งสินค้าสำเร็จ', color: 'red' },
    ]);

    // Use to disconnect relation //
    const confirmDisconnectRelation = ref(null);
    const failedDisconnectRelation = ref(null);
    const singleItemId: Ref<number> = ref(-1);
    const refetchQueries = ['getDeliveries', 'getInvoiceStats'];
    const batchDisconnectDeliveriesMutation = useMutation(batchDisconnectDeliveries, () => ({
      variables: {
        ids: selectedItemId,
      },
      refetchQueries,
    }));
    const singleDisconnectDeliveryMutation = useMutation(batchDisconnectDeliveries, () => ({
      variables: {
        ids: [singleItemId.value],
      },
      refetchQueries,
    }));
    function batchDisconnectDeliveriesHandler() {
      batchDisconnectDeliveriesMutation.mutate();
    }
    batchDisconnectDeliveriesMutation.onDone(() => {
      clearDeliveries();
      (confirmDisconnectRelation.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    batchDisconnectDeliveriesMutation.onError(() => {
      (failedDisconnectRelation.value as any).compose();
    });
    function singleDisconnectDeliveryHandler(id: number) {
      singleItemId.value = id;
      singleDisconnectDeliveryMutation.mutate();
    }
    batchDisconnectDeliveriesMutation.onDone(() => {
      (confirmDisconnectRelation.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
      singleItemId.value = -1;
    });
    batchDisconnectDeliveriesMutation.onError(() => {
      (failedDisconnectRelation.value as any).compose();
    });

    return {
      distanceTypeToChipClass,
      toCurrency,
      toCommaFormat,
      forceReload,

      modal,
      errorModal,
      editInvoice,
      createInvoice,
      close,
      editId,

      filter,
      orderNumberInput,
      clickDateHandler,

      selectedItemId,
      selectedItemHasInvoice,
      selectItem,
      clearDeliveries,

      orderListOption: orderList,
      ordersVariable,
      getDeliveries,
      getOrdersResult,

      orderStatusCounter,

      statusChartValue,

      singleDisconnectDeliveryHandler,
      batchDisconnectDeliveriesHandler,
      confirmDisconnectRelation,

      invoiceStats,

      // To get report
      getPDFReport,
    };
  },
});

export default BillList;
